import React from "react";
import { Loader2 } from "lucide-react";

/** Lightweight popup shown while the guest list is refreshing. */
export default function GuestListRefreshingPopup({ open }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center pointer-events-none p-4"
      role="status"
      aria-live="polite"
      aria-label="Refreshing list"
      data-testid="guest-list-refreshing-popup"
    >
      <div className="bg-white border border-black/[0.08] shadow-[0_8px_30px_rgba(0,0,0,0.12)] rounded-md2 px-5 py-4 flex items-center gap-3">
        <Loader2 className="w-5 h-5 animate-spin text-ink/70" strokeWidth={2.5} aria-hidden />
        <p className="font-ui font-semibold text-[15px] text-ink">Refreshing list</p>
      </div>
    </div>
  );
}
